module.exports = __webpack_public_path__ + "img/next.ddde58e6.png";